/**
 * GooglePlacesAddressForm - Backward Compatibility Export
 * 
 * MIGRATION NOTICE: This component is now a wrapper around UniversalLocationInput
 * 
 * This file maintains backward compatibility during the Universal Location Component
 * consolidation. All existing imports will continue to work without changes.
 * 
 * New implementations should use:
 * import { UniversalLocationInput } from '@/components/form/fields/UniversalLocationInput';
 * 
 * Legacy support maintained until Phase 3 cleanup (estimated 3 weeks)
 */

"use client";

// Import the compatibility wrapper
export { 
  GooglePlacesAddressForm as default,
  type GoogleAddressFields,
  type GooglePlacesAddressFormProps
} from '@/components/form/fields/UniversalLocationInput';

// Add deprecation logging for migration tracking
import { createLogger } from '@/utils/logger/devLogger';
const migrationLogger = createLogger('Migration');

// Log usage for migration tracking (development only)
if (process.env.NODE_ENV === 'development') {
  migrationLogger.info('📋 GooglePlacesAddressForm: Legacy import detected - consider migrating to UniversalLocationInput');
}